enum EVENT_TYPE {
  CUSTOM_DETAIL_OPTS_EVENT_HELPFUL = "CUSTOM_DETAIL_OPTS_EVENT_HELPFUL",
  CUSTOM_DETAIL_OPTS_EVENT_ANONYMOUS = "CUSTOM_DETAIL_OPTS_EVENT_ANONYMOUS",
  CUSTOM_DETAIL_OPTS_EVENT_DELETE = "CUSTOM_DETAIL_OPTS_EVENT_DELETE",
  CUSTOM_DETAIL_OPTS_EVENT_REPLY = "CUSTOM_DETAIL_OPTS_EVENT_REPLY",
}

export default EVENT_TYPE;
